import { render } from "./SelectedProducts.vue?vue&type=template&id=97b7b4be"
import script from "./SelectedProducts.vue?vue&type=script&lang=js"
export * from "./SelectedProducts.vue?vue&type=script&lang=js"

import "./SelectedProducts.vue?vue&type=style&index=0&id=97b7b4be&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__